<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2024-11-25 14:22:25
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-03-13 17:58:38
-->
<template>
  <div class="screen-root">
    <div id="screen">
      <TopHeader />
      <div class="main-content">
        <div class="left">
          <div class="card card1">
            <DataBoard ref="DataBoard" @click="showDialog" />
          </div>
          <div class="card-group">
            <div class="card">
              <SaleType />
            </div>
            <div class="card">
              <SaleTypeAmount />
            </div>
          </div>
          <div class="card card5">
            <PurchasingPie />
          </div>
          <div class="card-group">
            <div class="card">
              <CostProfit />
            </div>
            <div class="card">
              <SupplierSales />
            </div>
          </div>
        </div>
        <div class="center">
          <dv-border-box-8 :dur="4" class="flop">
            <Flop ref="Flop" />
          </dv-border-box-8>
          <div class="center-data">
            <div class="data-item">
              <div class="value">{{ totalData.totalSalesAmount }}</div>
              <div class="key">平台成交（万元）</div>
            </div>
            <div class="data-item" @click="showDialog(8)">
              <div class="value">
                {{ totalData.ruralEconomyAmount }}
                <!-- <span class="tip">(1~9月)</span> -->
              </div>
              <div class="key">新型农村集体经济组织(万元)</div>
            </div>
            <div class="data-item" @click="toTc">
              <div class="value">{{ totalData.ckPutTotalPriceTotal }}</div>
              <div class="key">校园餐销售额(万元)</div>
            </div>
          </div>
          <div class="map">
            <Map @change="handleMapIndexChange" />
          </div>
          <dv-decoration-12
            :scan-dur="4"
            :halo-dur="3"
            :color="['#00C0FE', 'transparent']"
          ></dv-decoration-12>
          <div class="card">
            <MapTable
              :item="mapActiveItem"
              @show="handleTableDetailShow"
              @showCompanyDetail="
                options => {
                  showDialog(7, options)
                }
              "
            />
          </div>
        </div>
        <div class="right">
          <div class="card card3">
            <!-- <ListingTime /> -->
            <SaleProductAmount />
            <SchoolProcurementRank />
          </div>
          <div class="card card2">
            <PriceQuotes />
          </div>
          <div class="card card5">
            <SalesAmount />
          </div>
          <!-- <div class="card-group">
            <div class="card2">
              <SalesAmount />
            </div>
            <div class="card2">
              <SalesVolume />
            </div>
          </div> -->
        </div>
      </div>
      <Product ref="ProductDialog" />
      <UserCus ref="UserCusDialog" />
      <BizCus ref="BizCusDialog" />
      <BizSupplier ref="BizSupplierDialog" />
      <UserOrder ref="UserOrderDialog" />
      <BizOrder ref="BizOrderDialog" />
      <TableDetail ref="TableDetail" />
      <AreaCompany ref="AreaCompany" />
      <AreaCompanyOrder ref="AreaCompanyOrder" />
      <GroupOrder ref="GroupOrder" />
    </div>
  </div>
</template>

<script>
import TopHeader from './components/TopHeader'
import DataBoard from './components/DataBoard'
import SaleType from './components/SaleType'
import CostProfit from './components/CostProfit'
import SalesAmount from './components/SalesAmount'
import SaleTypeAmount from './components/SaleTypeAmount'
// import SalesVolume from './components/SalesVolume'
import Flop from './components/Flop'
import Map from './components/Map'
// import ListingTime from './components/ListingTime'
import SupplierSales from './components/SupplierSales'
import PurchasingPie from './components/PurchasingPie'
import MapTable from './components/MapTable'
import PriceQuotes from './components/PriceQuotes'
import SaleProductAmount from './components/SaleProductAmount'
import SchoolProcurementRank from './components/SchoolProcurementRank'
import Product from './dialog/Product'
import UserCus from './dialog/UserCus'
import BizCus from './dialog/BizCus'
import BizSupplier from './dialog/BizSupplier'
import UserOrder from './dialog/UserOrder'
import BizOrder from './dialog/BizOrder'
import TableDetail from './dialog/TableDetail'
import AreaCompany from './dialog/AreaCompany'
import AreaCompanyOrder from './dialog/AreaCompanyOrder'
import GroupOrder from './dialog/GroupOrder'
import { platformTotal } from '@/api/dashboard'
import to from 'await-to'
let _timer
export default {
  components: {
    TopHeader,
    DataBoard,
    SaleType,
    Flop,
    Map,
    CostProfit,
    SalesAmount,
    SaleTypeAmount,
    // SalesVolume,
    // ListingTime,
    SupplierSales,
    PurchasingPie,
    MapTable,
    PriceQuotes,
    Product,
    UserCus,
    BizCus,
    BizSupplier,
    UserOrder,
    BizOrder,
    TableDetail,
    AreaCompany,
    AreaCompanyOrder,
    SaleProductAmount,
    SchoolProcurementRank,
    GroupOrder,
  },
  data() {
    return {
      mapActiveItem: {},
      totalData: {},
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscKey)
    this.handleScreenAuto()
    window.onresize = () => this.handleScreenAuto()
    this.initNumData()
    _timer = setInterval(() => {
      this.initNumData()
    }, process.env.VUE_APP_LTIME)
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleEscKey)
    clearInterval(_timer)
    window.onresize = null
  },
  methods: {
    toTc() {
      this.$router.push('/tc')
    },
    async initNumData() {
      const [res, err] = await to(platformTotal({}))
      if (err) return
      this.$refs.DataBoard.initData(res)
      this.$refs.Flop.initData(res.data.platformSaleTotal)
      this.totalData = res.data
    },
    //数据大屏自适应函数
    handleScreenAuto() {
      const designDraftWidth = 4096 //设计稿的宽度
      const designDraftHeight = 2160 //设计稿的高度
      //根据屏幕的变化适配的比例
      const scale =
        document.documentElement.clientWidth / document.documentElement.clientHeight <
        designDraftWidth / designDraftHeight
          ? document.documentElement.clientWidth / designDraftWidth
          : document.documentElement.clientHeight / designDraftHeight
      //缩放比例
      document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`
    },
    showDialog(index, options) {
      console.log(`output->index`, this.$refs)
      for (const key in this.$refs) {
        if (Object.hasOwnProperty.call(this.$refs, key)) {
          const element = this.$refs[key]
          if (element.close) element.close()
        }
      }
      if (index == 1) {
        this.$refs['ProductDialog'].show()
      }
      if (index == 2) {
        this.$refs['UserCusDialog'].show()
      }
      if (index == 3) {
        this.$refs['BizCusDialog'].show()
      }
      if (index == 4) {
        this.$refs['BizSupplierDialog'].show()
      }
      if (index == 5) {
        this.$refs['UserOrderDialog'].show()
      }
      if (index == 6) {
        this.$refs['BizOrderDialog'].show()
      }
      if (index == 7) {
        this.$refs['AreaCompany'].show(options)
      }
      if (index == 8) {
        this.$refs['AreaCompanyOrder'].show()
      }
      if (index == 9) {
        this.$refs['GroupOrder'].show()
      }
    },
    handleTableDetailShow({ col, data }) {
      for (const key in this.$refs) {
        if (Object.hasOwnProperty.call(this.$refs, key)) {
          const element = this.$refs[key]
          if (element.close) element.close()
        }
      }
      this.$refs['TableDetail'].show(col, data)
    },
    handleEscKey(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        for (const key in this.$refs) {
          if (Object.hasOwnProperty.call(this.$refs, key)) {
            const element = this.$refs[key]
            if (element.close) element.close()
          }
        }
      }
    },
    async handleMapIndexChange(item) {
      // const [res, err] = await to(
      //   areaCompanyList({
      //     areaCode: item.districtCode,
      //   }),
      // )
      // if (err) return
      // item.companyList = res.data
      this.mapActiveItem = item
    },
  },
}
</script>
<style lang="scss">
.screen-root {
  color: #fff;
  height: 100%;
  width: 100%;
  background-color: #050d4c;

  .bg {
    height: 100%;
    width: 100%;
  }

  #screen {
    overflow: hidden;
    display: inline-block;
    width: 4096px; //设计稿的宽度
    height: 2160px; //设计稿的高度
    transform-origin: 0 0;
    position: absolute;
    left: 50%;
    top: 0;

    // background-color: #050d4c;
    .main-content {
      width: 100%;
      height: calc(100% - 161px);
      display: flex;
      box-sizing: border-box;

      > .left,
      > .right {
        box-sizing: border-box;
        height: 100%;
      }

      .left {
        padding: 0;
      }

      .right {
        padding: 0;
      }
    }

    .card {
      width: 1321px;
      background-size: contain;
      background-repeat: no-repeat;

      &.card1 {
        height: 536px;
        background-image: url('~@/img/datav/card_bg_1.png');
      }

      &.card2 {
        height: 574px;
        background-image: url('~@/img/datav/card_bg_2.png');
        background-size: 100% 100%;
      }

      &.card3 {
        display: flex;
        margin-top: -10px;

        > div {
          width: 50%;
          height: 100%;
          background-image: url('~@/img/datav/card_bg_6.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }

      &.card5 {
        height: 428px;
        margin-bottom: 12px;
        background-image: url('~@/img/datav/card_bg_5.png');
        background-size: 100% 100%;
      }
    }

    .card-group {
      display: flex;
      justify-content: space-between;
      margin-top: -10px;

      .card {
        width: 654px;
        height: 503px;
        background-image: url('~@/img/datav/card_bg.png');
      }

      .card2 {
        width: 654px;
        height: 448px;
        background-image: url('~@/img/datav/card_bg_g2.png');
        background-size: 100% 100%;
      }
    }

    .right {
      .card3 {
        height: 854px;
      }

      .card2 {
        height: 602px;
        margin-top: -10px;
      }

      .card5 {
        height: 525px;
      }
    }

    .center {
      overflow: hidden;
      box-sizing: border-box;
      position: relative;
      height: 100%;
      padding: 35px 36px 0 36px;

      .flop {
        width: 1305px;
        height: 250px;
        background: url('~@/img/datav/flop_bg.png') no-repeat center;
        margin-bottom: 4px;
      }

      .map {
        margin-top: -43px;
        position: relative;
        width: 1306px;
        height: 1144px;
        background: url('~@/img/datav/map_bg.png') no-repeat center;
        margin-bottom: 16px;

        .map-container {
          position: relative;
          z-index: 999;
        }
      }

      .card {
        position: relative;
        z-index: 9999;
        height: 387px;
        background-image: url('~@/img/datav/card_bg_4.png');
        background-color: #050d4c;
      }

      .dv-decoration-12 {
        z-index: 699;
        position: absolute;
        left: 51%;
        top: 56%;
        transform: translate(-50%, -50%);
        width: 1220px;
        height: 1220px;
      }

      .center-data {
        width: 1305px;
        display: flex;
        justify-content: center;

        // justify-content: space-around;
        .data-item {
          width: 287px;
          height: 196px;
          text-align: center;
          padding-top: 8px;
          margin-right: 111px;

          &:last-of-type {
            margin-right: 0;
          }

          .value {
            line-height: 64px;
            font-weight: normal;
            font-size: 48px;
            color: #ecf8ff;
            margin-bottom: 4px;
            white-space: nowrap;

            .tip {
              font-size: 18px;
              line-height: 18px;
            }
          }

          .key {
            line-height: 21px;
            font-weight: normal;
            font-size: 21px;
            color: #e0eafa;
          }

          &:nth-of-type(1) {
            background: url('~@/img/datav/center_data_bg_1.png');
          }

          &:nth-of-type(2) {
            background: url('~@/img/datav/center_data_bg_2.png');
          }

          &:nth-of-type(3) {
            background: url('~@/img/datav/center_data_bg_3.png');
          }
        }
      }
    }
  }
}
</style>
